// extracted by mini-css-extract-plugin
export default {"bgc":"DeleteBook_bgc__wsjYB","title":"DeleteBook_title__c19ti","wrapper":"DeleteBook_wrapper__JcwuW","back":"DeleteBook_back__mWhV0"};